import './app.scss';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import {AppHeader, AppTitle, Navigation} from "app/components/AppHeader"
import AppContainer from "app/components/AppContainer/AppContainerComponent"
import Homepage from "./pages/homepage";
import Question from "./pages/question";
import Login from './pages/login';
import ChangePassword from './pages/changepassword';
import InDepth from './pages/indepth';
import AdHocSurvey from './pages/adhocsurvey';
import Nqtemplate from './pages/admin/nqtemplate';
import Role from './pages/admin/role';
import User from './pages/admin/user';
import SubSurvey from './pages/admin/subsurvey';
import SurveyHistory from './pages/surveyhistory';
import Region from './pages/admin/region';
import Channel from './pages/admin/channel';
import DemoSet from './pages/admin/demoset';
import HoneypotSet from './pages/admin/honeypotset';
import ApsResponseDownload from './pages/apsreportdownload';
import ResponseDownload from './pages/ediaryresponsedownload';
import ResponseDownloadNq from './pages/ediaryresponsedownloadnq';
import ReportDownload from './pages/ediaryreportdownload';
import MediaType from './pages/admin/mediatype';
import Quota from './pages/quotas';
import QuotaMonitor from './pages/quotasmonitor';
import DynamicDemo from './pages/admin/dynamicdemo';
import {adHocSurveyTypes} from './constants/adhoc-survey-types'
import { useState } from "react";
import AuthService from "./services/auth.service";
import { GlobalStateProvider } from './contexts/GlobalStateContext';
import FileDownload from './components/FileDownload';
import ConfiguredCopyStatus from './components/ConfiguredCopyStatus';
import EDiaryApiKeyManagement from './pages/ediaryapikeymanagement';
import StaticTexts from './pages/admin/statictexts';

function App() {
	const [panelConfig, setPanelConfig] = useState();
	const [userPermissions, setUserPermissions] = useState();	

	function getPanelConfig(panelConfig) {		
		setPanelConfig(panelConfig);
	}

	function getUserPermissions(userPermissions) {
		setUserPermissions(userPermissions);
	}

	function loggedToChangePassword() {
		let user = AuthService.getCurrentUser();	
		return user?.resetPassword === true;		
	}

	function isModuleEnabled(module, userModulePermission) {
		return panelConfig?.modules.includes(module) && userModulePermission && !loggedToChangePassword();
	}

	function isInDepthAskAlwaysEnabled() {
		return panelConfig?.enabledAskAlways;
	}

	return (
		<div className="App">
			<GlobalStateProvider>			
				<Router>      
					<Switch>
					<Route exact path="/login" component={Login} />
					<Route exact path="/" component={Login} />				
					<AppContainer getPanelConfig={getPanelConfig} getUserPermissions={getUserPermissions}>
						<AppHeader>
							<AppTitle panelConfig={panelConfig}/>
							<Navigation selectedItem={window.location.pathname} panelConfig={panelConfig} userPermissions={userPermissions} disableNavigation={loggedToChangePassword()} />
						</AppHeader>
						{
							(isModuleEnabled("apsresponsedownload", userPermissions?.CanReadRespondentResponse) ||
						isModuleEnabled("ediaryresponsedownload", userPermissions?.CanReadRespondentResponse) ||
						isModuleEnabled("ediaryresponsedownloadnq", userPermissions?.CanReadRespondentResponse) ||
						isModuleEnabled("reportdownload", userPermissions?.CanReadReportDownload)) &&
							<FileDownload />
						}
						<ConfiguredCopyStatus />       
						<Route exact path="/question">
							{isModuleEnabled("question", userPermissions?.CanReadQuestion) && <Question userPermissions={userPermissions} languages={panelConfig.languages}/> }
						</Route>
						<Route path="/indepth/:surveyTest">
							{isModuleEnabled("indepth", userPermissions?.CanReadIndepth) && <InDepth isSurveyTest={true} userPermissions={userPermissions}/> }
						</Route>
						<Route exact path="/indepth">
							{isModuleEnabled("indepth", userPermissions?.CanReadIndepth) && <InDepth userPermissions={userPermissions} isAskAlwaysEnabled={isInDepthAskAlwaysEnabled()} /> }
						</Route>
						<Route exact path="/generics">
							{isModuleEnabled("generics", userPermissions?.CanReadGenerics) && <AdHocSurvey surveyType={adHocSurveyTypes.Generics} userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/fiveminex">
							{isModuleEnabled("fiveminex", userPermissions?.CanReadFiveMinex) && <AdHocSurvey surveyType={adHocSurveyTypes.FiveMinex} userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/nqtemplate">
							{isModuleEnabled("nqtemplate", userPermissions?.CanReadNqTemplate) && <Nqtemplate userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/role">
							{isModuleEnabled("role", userPermissions?.CanReadRole) && <Role userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/user">
							{isModuleEnabled("user", userPermissions?.CanReadUser) && <User userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/subsurvey">
							{isModuleEnabled("subsurvey", userPermissions?.CanReadSubSurvey) && <SubSurvey userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/surveyhistory">
							{isModuleEnabled("surveyhistory", userPermissions?.CanDownloadCodeBook) && <SurveyHistory userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/region">
							{isModuleEnabled("region", userPermissions?.CanReadRegion) && <Region userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/channel">
							{isModuleEnabled("channel", userPermissions?.CanReadChannel) && <Channel userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/demoset">
							{isModuleEnabled("demoset", userPermissions?.CanChangeDemoQuestion) && <DemoSet userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/honeypotset">
							{isModuleEnabled("honeypotset", userPermissions?.CanChangeHoneypotQuestion) && <HoneypotSet userPermissions={userPermissions}/>}
						</Route>					
						<Route exact path="/apsresponsedownload">
							{isModuleEnabled("apsresponsedownload", userPermissions?.CanReadRespondentResponse) && <ApsResponseDownload userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/responsedownload">
							{isModuleEnabled("ediaryresponsedownload", userPermissions?.CanReadRespondentResponse) && <ResponseDownload userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/responsedownloadnq">
							{isModuleEnabled("ediaryresponsedownloadnq", userPermissions?.CanReadRespondentResponse) && <ResponseDownloadNq userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/reportdownload">
							{isModuleEnabled("reportdownload", userPermissions?.CanReadReportDownload) && <ReportDownload userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/ediaryapikeymanagement">
							{isModuleEnabled("reportdownload", userPermissions?.CanReadReportDownload) && <EDiaryApiKeyManagement/>}
						</Route>
						<Route exact path="/mediatype">
							{isModuleEnabled("mediatype", userPermissions?.CanReadMediaType) && <MediaType userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/quotaManagement">
							{isModuleEnabled("fiveminex", userPermissions?.CanReadQuota) && <Quota userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/quotaMonitor">
							{isModuleEnabled("fiveminex", userPermissions?.CanReadQuota) && <QuotaMonitor userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/quotaScreener">
							{isModuleEnabled("fiveminex", userPermissions?.CanReadFiveMinexScreener) && <AdHocSurvey surveyType={adHocSurveyTypes.AdHocScreener} userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/dynamicdemo">
							{isModuleEnabled("dynamicdemo", userPermissions?.CanReadDynamicDemo) && <DynamicDemo userPermissions={userPermissions}/>}
						</Route>
						<Route exact path="/statictexts">
							{isModuleEnabled("statictext", userPermissions?.CanReadStaticText) && <StaticTexts userPermissions={userPermissions} languages={panelConfig?.languages || []}/>}
						</Route>
						<Route exact path="/changepassword">
							{loggedToChangePassword() && <ChangePassword />}
						</Route>
						<Route exact path="/homepage">
							<Homepage />
						</Route>
					</AppContainer>
					</Switch>
				</Router> 
			</GlobalStateProvider>    
		</div>
	);
}

export default App;